const styles = theme => ({
    dialogRoot: {
        minWidth: 600,
        '@media(max-width:768px)': {
            minWidth: 'inherit',
        }
    },
    dialogContent: {
        padding: 0,
        minWidth: 600,
        backgroundColor: theme.palette.background.default,
        '@media(max-width:768px)': {
            minWidth: 'inherit',
        }
    },
    contentBody: {
        padding: theme.spacing(2)
    },
    chooserPanel: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.surface
    },
    chipContainer: {
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    chip: {
        minWidth: 100,
        marginRight: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            marginRight: theme.spacing(1),
            minWidth: 100,
        }
    },
    scheduledDetails: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
        fontSize: 12
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.background.paper,
        },
    }
});

export default styles;